module.exports = __webpack_public_path__ + "img/mastercard.67c3e61c.svg";